<template>
  <div>
    <base-header class="pb-6" type="pink">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Agregar Documento</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <div class="container-fluid mt--6">
      <b-card no-body class="mb-4">
  
        <b-card-header>
          <h3 class="mb-0">Información del Documento</h3>
        </b-card-header>
  
        <b-card-body>
          <b-form @submit.prevent="onSubmit">

            <h6 class="heading-small text-muted mb-4">Información General</h6>
            <!-- Row 1 -->
            <b-row>
              <!-- Title -->
              <b-col>
                <base-input label="Título" type="text" v-model="document.title"></base-input>
              </b-col>

            </b-row>

            <!-- Row 3 -->
            <b-row>
              <!-- Category -->
              <b-col>
                <base-input label="Categoría">
                  <el-select v-model="document.category" filterable placeholder="Categoría">
                    <el-option v-for="option in categoryOptions" :key="option.label" :label="option.label" :value="option.value">
                    </el-option>
                  </el-select>
                </base-input>
              </b-col>

            </b-row>

            <!-- Row 2 -->
            <b-row>
              <!-- Upload Date -->
              <b-col>
                <base-input label="Fecha de subida">
                  <b-form-datepicker id="uploadDate" v-model="document.uploadDate"></b-form-datepicker>
                </base-input>
              </b-col>
            </b-row>
  

            <!-- Demo Document Plan -->
            <b-row>
              <b-col>
                <base-input label="¿Documento de prueba?">
                  <b-form-checkbox v-model="document.trialDocument"><span>Mostrar como documento de prueba</span></b-form-checkbox>
                </base-input>
              </b-col>
            </b-row>


            <hr class="my-4">

            <h6 class="heading-small text-muted mb-2">Documento</h6>

            <!-- File -->
            <b-row>
              <b-col>
                <div>
                  <base-input label="Archivo">
                    <b-form-file browse-text="Buscar" v-model="document.file" placeholder="Seleccione un archivo..." size="md"></b-form-file>
                  </base-input>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <!-- Thumbnail -->
              <b-col>
                <base-input label="Thumbnail">
                  <el-select v-model="thumbnailType" filterable placeholder="Selecciona una opción...">
                    <el-option v-for="option in thumbnailOptions" :key="option.label" :label="option.label" :value="option.value">
                    </el-option>
                  </el-select>
                </base-input>
                <div v-if="thumbnailType === 'custom'">
                  <base-input>
                    <b-form-file accept="image/*" browse-text="Buscar" v-model="document.image" placeholder="Seleccione una imagen..." size="sm"></b-form-file>
                  </base-input>
                </div>
              </b-col>
            </b-row>
            
            <!-- Submit -->
            <b-button type="submit" variant="primary" :disabled="documentSubmitted">
              <span>Subir plan </span>
              <span v-if="documentSubmitted"><i class="fas fa-spinner fa-spin"></i></span>
            </b-button>
          </b-form>
        </b-card-body>
  
      </b-card>

      <!-- Test Form -->
      <!-- <b-card class="mt-3" header="Form Data Result">
        <pre class="m-0">{{ document }}</pre>
      </b-card> -->

    </div>

  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { Select, Option } from 'element-ui'
import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
import db from '@/firebase/init'
import firebase from 'firebase/app' 
import 'firebase/storage'
import Compress from 'compress.js'
import { mainStorage } from '@/store/main.js'
import { documentStorage } from '@/store/documents.js'

export default {
  components: {
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    DropzoneFileUpload
  },
  data() {
    return {
      document: {
        title: null,
        category: null,
        uploadDate: null,
        thumbnailURL: null,
        image: null,
        file: null,
        trialDocument: false
      },
      categoryOptions: mainStorage.state.documentCategoryOptions,
      thumbnailOptions: [
        { label: "Usar thumbnail predeterminado", value: 'default' },
        { label: "Usar thumbnail personalizado", value: 'custom' }
      ],
      thumbnailType: 'default',
      disableInputs: true,
      documentSubmitted: false,
      placeholderThumbnailURL: "https://firebasestorage.googleapis.com/v0/b/pink-workout.appspot.com/o/thumbnails%2Fdefault_thumbnail.PNG?alt=media&token=34241c1d-5ccf-4fa4-8b10-10671352e298",
      resizedThumbnail: null
    }
  },
  methods: {
    async onSubmit() {
      this.documentSubmitted = true
      await this.addFirestoreDocument()
    },
    async addFirestoreDocument() {
      try {
        var documentRef = await db.collection('documents').add({
          title: this.document.title,
          category: this.document.category,
          uploadDate: this.document.uploadDate,
          // thumbnailURL: this.document.thumbnailURL,
          trialDocument: this.document.trialDocument
        })

        // Upload the file and get its download URL
        var fileURL = await this.uploadDocumentFile(documentRef.id)

        // Upload the thumbnail and get its download URL
        var thumbnailURL = await this.setThumbnail(documentRef.id)

        // Update the document with the file and thumbnail download URLs
        await documentRef.update({
          "fileURL": fileURL,
          "thumbnailURL": thumbnailURL
        })

        // Reset the fetched status at the document source
        documentStorage.resetFetchedStatus()

        this.$router.push({ name: 'DocumentsManagement'})
        this.documentSubmitted = false

      } catch (err) {
        this.documentSubmitted = false
        console.log(err.message)
      }

    },
    async uploadDocumentFile(documentID) {

      try {
        // Set the reference to the firebase storage
        const storageRef = firebase.storage().ref('documents/files/' + documentID)
        
        // Upload the file and get the download URL
        var res = await storageRef.put(this.document.file)
        const fileURL = await res.ref.getDownloadURL()

        return fileURL
      } catch (err) {
        console.log(err.message)
        return 'Error'
      }
      
    },
    async setThumbnail(documentID) {

      switch (this.thumbnailType) {

        case 'default':
          // Set the placeholder image
          return this.placeholderThumbnailURL
          break

        case 'custom':
          // Upload a custom thumbnail
          return await this.uploadCustomThumbnail(documentID)
          break
      }
    },
    async uploadCustomThumbnail(documentID) {
      if (this.document.image) {

        try {
          // Resize the image
          const resizedThumbnail = await this.resizeThumbnail(this.document.image)

          // Set reference to the firebase storage
          const storageRef = firebase.storage().ref('documents/thumbnails/' + documentID)

          // Upload the image and get the download URL
          var res = await storageRef.put(resizedThumbnail)
          const imgURL = await res.ref.getDownloadURL()

          return imgURL

        } catch (err) {
          console.log(err)
          // Return a placeholder image if the upload didn't complete
          return this.placeholderThumbnailURL
        }

      } else {
        // Put a placeholder image if no thumbnail was set
        return this.placeholderThumbnailURL
      }
    },
    async resizeThumbnail(file) {

      const compress = new Compress()

      const results = await compress.compress([file], {
        size: 0.02,
        maxWidth: 300,
        resize: true
      })

      const image = results[0].data
      const imgExt = results[0].ext

      return Compress.convertBase64ToFile(image, imgExt)

    }
  },
  computed: {

  },
  mounted() {
    let today = new Date()
    this.document.uploadDate = today.toISOString().substring(0,10)
  }
}
</script>

<style>

</style>